import DeleteCueComponent from './deleteCue.component';

export const deleteCueModule = {
	name: 'deleteCueComponent',
};

export default angular
	.module(deleteCueModule.name, [])
	.component('deleteCue', new DeleteCueComponent()).name;
